
// **** Better way to set special products in one place **** ////
var specialProduct1 = false;
var specialProduct2 = false;
var specialProduct3 = false;
var specialProduct4 = false;
var specialProduct5 = false;
var specialProduct6 = false;
var specialProduct7 = false;

for (var i = 0; i < crItems.length; i++ ){
  var itemCollections = crItems[i].collections
  var itemTitle = crItems[i].name;
  if (itemTitle === 'Pickup Instore') continue;
  //console.log({itemTitle})  
  console.log('-->', itemCollections)
 
  if (itemCollections.toLowerCase().indexOf('2026 VIC Head of the Schoolgirls'.toLowerCase()) > -1) {
    specialProduct1 = true;
  }   

  if (itemCollections.toLowerCase().indexOf('2026 RV State Championships'.toLowerCase()) > -1) {
    specialProduct2 = true;
  }   

  if (itemCollections.toLowerCase().indexOf('2026 Vic Junior School State Championships'.toLowerCase()) > -1) {
    specialProduct3 = true;
  }   

  if (itemCollections.toLowerCase().indexOf('2026 NSW Schoolgirl Head of the River'.toLowerCase()) > -1) {
    specialProduct4 = true;
  }   

  if (itemCollections.toLowerCase().indexOf('2026 Netball Victoria State Titles'.toLowerCase()) > -1) {
    specialProduct5 = true;
  }   

  if (itemCollections.toLowerCase().indexOf('2026 NSW Rowing Championships'.toLowerCase()) > -1) {
    specialProduct6 = true;
  } 
  
  if (itemCollections.toLowerCase().indexOf('2026 SA Head of the River - Parents Range'.toLowerCase()) > -1) {
    specialProduct7 = true;
  } 

  if (itemCollections.toLowerCase().indexOf('2026 SA Head of the River'.toLowerCase()) > -1) {
    specialProduct7 = true;
  }   
}

for (var i = 0; i < stores.length; i++) {
    if (!stores[i]) continue;
    var storeName = stores[i].name.toLowerCase();
    var storeId = stores[i].storeID;

    if (specialProduct1 === true) {
        if (storeId !== 6299) {
            delete stores[i];
        }
    }

    if (specialProduct2 === true) {
        if (storeId !== 489) {
            delete stores[i];
        }
    }

    if (specialProduct3 === true) {
        if (storeId !== 489) {
            delete stores[i];
        }
    }

    if (specialProduct4 === true) {
        if (storeId !== 4642) {
            delete stores[i];
        }
    }

    if (specialProduct5 === true) {
        if (storeId !== 314) {
            delete stores[i];
        }
    }

    if (specialProduct6 === true) {
        if (storeId !== 3778) {
            delete stores[i];
        }
    }

    if (specialProduct7 === true) {
        if (storeId !== 6178) {
            delete stores[i];
        }
    }
}